import { useState } from "react";
import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { FaFileDownload } from "react-icons/fa";
import { TbMailShare } from "react-icons/tb";
import { Grid, IconButton, Tooltip } from "@mui/material";

import { useAxios } from "../../../hooks";
import { Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";
import { alert } from "../../../redux/slices/alertSlice";
import ReportDialog from "./ReportDialog";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.publicisBlue};
  color: ${colors.publicisBlue};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  border-radius: 10px;
  &:hover {
    border: 1px solid ${colors.publicisBlue};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({ reports, setPage, setSearchKey, loading }) {
  function convertDate(d) {
    let date = new Date(d);

    return (
      date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
    );
  }

  const [reportDialog, setReportDialog] = useState({ state: false });

  var columns = [
    {
      name: "campaign_name",
      label: "Campaign Name",
    },

    {
      name: "campaign_period",
      label: "Campaign Period",
    },

    {
      name: "audience_name",
      label: "Audience Name",
    },

    {
      name: "audience_cpm",
      label: "Audience CPM",
    },

    {
      name: "audience_size",
      label: "Audience Size",
    },

    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "campaign_name") {
      return value;
    }

    if (col.name === "campaign_period") {
      return (
        convertDate(row.start_duration) + " - " + convertDate(row.end_duration)
      );
    }

    if (col.name === "audience_name") {
      return value;
    }

    if (col.name === "audience_cpm") {
      return value;
    }

    if (col.name === "audience_size") {
      return value;
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Report">
            <Icon>
              <CgEye
                onClick={() =>
                  setReportDialog({
                    state: true,
                    campaignID: row.campaign_id,
                  })
                }
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>
        </div>
      );
    }
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar
              setPage={setPage}
              setSearchKey={setSearchKey}
              reports={reports}
            />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={reports}
        />
      </Grid>
      <ReportDialog
        reportDialog={reportDialog}
        setReportDialog={setReportDialog}
      />
    </Grid>
  );
}

export function ToolBar({ setPage, setSearchKey, reports }) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { activeBrand } = useSelector((state) => state.memberDetails);

  const [buttonLoading, setButtonLoading] = useState({
    email: false,
    download: false,
  });

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "end",
      }}
    >
      <div style={{ alignSelf: "center", marginRight: "20px" }}>
        <Search setPage={setPage} setSearchKey={setSearchKey} />
      </div>

      {reports.length > 0 && (
        <div>
          <Tooltip title="Download Report">
            <Icon loading={buttonLoading.download}>
              <FaFileDownload
                onClick={() => {
                  setButtonLoading((prev) => ({
                    ...prev,
                    download: true,
                  }));
                  axios({
                    url:
                      "/download/campaign/report?action=download&brand_id=" +
                      activeBrand.ID,
                    disableError: true,
                  }).then((response) => {
                    if (response.status) {
                      dispatch(
                        alert({
                          type: "success",
                          message: response.message.displayMessage,
                        })
                      );
                      window.location.href = response.data?.reportUrl;
                    }
                    setButtonLoading((prev) => ({
                      ...prev,
                      download: false,
                    }));
                  });
                }}
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>

          <Tooltip title="Share Report">
            <Icon loading={buttonLoading.email}>
              <TbMailShare
                onClick={() => {
                  setButtonLoading((prev) => ({
                    ...prev,
                    email: true,
                  }));
                  axios({
                    url:
                      "/download/campaign/report?action=email&brand_id=" +
                      activeBrand.ID,
                    disableError: true,
                  }).then((response) => {
                    if (response.status) {
                      dispatch(
                        alert({
                          type: "success",
                          message: response.message.displayMessage,
                        })
                      );
                    } else {
                      dispatch(
                        alert({
                          type: "error",
                          message: response.message,
                        })
                      );
                    }
                    setButtonLoading((prev) => ({
                      ...prev,
                      email: false,
                    }));
                  });
                }}
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>
        </div>
      )}
    </div>
  );
}
